import React from 'react';
import { Col, Row } from 'reactstrap';
import Readstories from './readStories'


const dueDiligenceProcess = () => (
	<Col sm="12" xs="12" md="12" lg="12" style={{ overflow: 'hidden' }} >


		<h2 className="text-heading-giveAssured" >An overview of our due-diligence process </h2>
		<p>We go to the extent of meeting the actual people that the nonprofits serve. Yes, they sometimes live in remote villages, but that doesn’t stop us because we take our promise to bring you trustworthy options very seriously. Read stories of our visits <a href="http://blog.giveindia.org/giveassured-ngo-visits/giveassured-built-with-integrity-executed-with-compassion/">here</a></p>
		  <p>And, we do this not just once,  the nonprofits are reviewed at initial listing and then periodically throughout the time that they are active on our site. </p>
		 <p>We regularly review the norms of our due diligence and verification process to keep them in line with the laws of the land. We evolve to keep ourselves at the cutting edge of technology and operations. This helps us review the process and norms regularly so that you can always be sure that your donations are always reaching the right people in the right way.
		</p>
		<Row>
			<Col xs="12" sm="12" md="6" lg="6" className=" d-flex justify-content-center">
				<img className="image-due-diligence img-main" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/GA-due-diligence-image1.jpg" alt="Due diligence" />
			</Col>
			<Col xs="12" sm="12" md="6" lg="6">
				<h4 >An overview of our due-diligence process </h4>
				<p>We understand that you place your trust in us when you donate through us. It is important to us that we assure you that your donations reach the people you want them to.
				</p>
				<p>We not only verify the books of the nonprofits but go on ground where the program is implemented to meet some of the people to ensure that we keep your trust that your donations are utilised as promised.
				</p>


			</Col>
		</Row>

		<h3 style={{ color: '#ff5050', paddingTop: '2rem' }}>What we check   </h3>
		<Row>
			<Col xs="12" sm="12" md="6" lg="6">
				<img className="image-due-diligence image-mobile" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/GA-due-diligence-image2.jpg" alt="Due diligence" />


				<p><b>Credibility of the requested donation amount:</b></p>
				<p>We verify all the relevant expenses of every program and then validate it against the donation amount that is requested for the program. The objective is to mitigate the risk of fraud and establish that the amount of donation that we ask from you is within limits of actual costs of the programme. We travel across the country no matter how remote the areas of execution are, to make sure that the program works the way it is meant to.
				</p>
			</Col>
			<Col xs="12" sm="12" md="6" lg="6" className=" d-flex justify-content-center">
				<img className="image-due-diligence image-desktop" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/GA-due-diligence-image2.jpg" alt="Due diligence" />

			</Col>
		</Row>
		<br/>
		<Row>
			<Col xs="12" sm="12" md="6" lg="6" className=" d-flex justify-content-center">
				<img className="image-due-diligence" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/GA-due-diligence-image3.jpg" alt="images" />
			</Col>
			<Col xs="12" sm="12" md="6" lg="6">
				<p><b>The benefits reaching the right people:</b></p>
				<p>We visit the actual beneficiaries that the program is serving, without prior intimation to the nonprofit to directly validate if they have receive the benefits that they were supposed to receive according to the program. This is done to give you the confidence that your donations reach the right people in need.</p>


			</Col>
		</Row>

		<p style={{ paddingTop: '2rem' }}><Readstories/></p>

		<style global jsx>
			{
				`
		 .image-due-diligence{
			 width: 100%;


		 }
		 .img-main{
			 padding-top: 8px;
		 }
		 		 				@media (max-width: 768px) {
		 				 text-topic-h2{
		 				padding-top: 15px;
		 			 }
		 				}

						@media (max-width: 768px) {
						.image-mobile{
						 width: 100%;
						 padding-top: 20px;
						 padding-bottom: 20px;
					 }
						}
						@media (min-width: 769px){
							.image-mobile{
							display: none;
						 }
						 }


						@media (min-width: 768px) {
						.image-desktop{
						 width: 100%;
						 padding-top: 20px;
						 padding-bottom: 20px;

							}
						}
						@media (max-width: 769px) {
							.image-desktop{
								display: none;
							}
						}


			`
			}
		</style>

	</Col>


);

export default dueDiligenceProcess;
